module.exports = __webpack_public_path__ + "static/media/astonntg50map.08539220.jpg";